/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_PausedInputs */

const th_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดชั่วคราว`)
};

const en_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

const ja_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一時停止中`)
};

const zh_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已暂停`)
};

const es_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En pausa`)
};

const pt_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausado`)
};

const id_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dijeda`)
};

const fr_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En pause`)
};

const tl_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-pause`)
};

const vi_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạm dừng`)
};

const ko_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일시정지됨`)
};

const de_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausiert`)
};

const ru_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза`)
};

const tr_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duraklatıldı`)
};

const it_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In pausa`)
};

const pl_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstrzymano`)
};

const uk_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пауза`)
};

const hi_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रुका हुआ`)
};

const ar_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موقوف مؤقتًا`)
};

const ms_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dijeda`)
};

const bn_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থামানো`)
};

const zh_tw2_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已暫停`)
};

const zh_hk2_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已暫停`)
};

const ur_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رکا ہوا`)
};

const fa_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوقف`)
};

const sw_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imesimamishwa`)
};

const nl_video_paused = /** @type {(inputs: Video_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gepauzeerd`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Video_PausedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_paused = /** @type {((inputs?: Video_PausedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_PausedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_paused(inputs)
	if (locale === "ja") return ja_video_paused(inputs)
	if (locale === "zh") return zh_video_paused(inputs)
	if (locale === "es") return es_video_paused(inputs)
	if (locale === "pt") return pt_video_paused(inputs)
	if (locale === "id") return id_video_paused(inputs)
	if (locale === "fr") return fr_video_paused(inputs)
	if (locale === "tl") return tl_video_paused(inputs)
	if (locale === "vi") return vi_video_paused(inputs)
	if (locale === "ko") return ko_video_paused(inputs)
	if (locale === "de") return de_video_paused(inputs)
	if (locale === "ru") return ru_video_paused(inputs)
	if (locale === "tr") return tr_video_paused(inputs)
	if (locale === "it") return it_video_paused(inputs)
	if (locale === "pl") return pl_video_paused(inputs)
	if (locale === "uk") return uk_video_paused(inputs)
	if (locale === "hi") return hi_video_paused(inputs)
	if (locale === "ar") return ar_video_paused(inputs)
	if (locale === "ms") return ms_video_paused(inputs)
	if (locale === "bn") return bn_video_paused(inputs)
	if (locale === "zh-TW") return zh_tw2_video_paused(inputs)
	if (locale === "zh-HK") return zh_hk2_video_paused(inputs)
	if (locale === "ur") return ur_video_paused(inputs)
	if (locale === "fa") return fa_video_paused(inputs)
	if (locale === "sw") return sw_video_paused(inputs)
	if (locale === "nl") return nl_video_paused(inputs)
	return en_video_paused(inputs)
});